// counter.ts
import { ActionReducer, Action } from '@ngrx/store';


export function chatData(state: string='hello', action: Action) {
	  		console.log(action.type)
	  		return action.type; 
	  		
}


// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/chat/action.ts